import React, { useState, useEffect } from 'react';

const SeedVerse = () => {
  // Define the verses
  const verses = [
    {
      text: "Truly I tell you, unless a grain of wheat falls to the ground and dies, it remains only a single seed. But if it dies, it produces many seeds.",
      reference: "John 12:24"
    },
    {
      text: "The kingdom of heaven is like a mustard seed, which a man took and planted in his field. Though it is the smallest of all seeds, yet when it grows, it is the largest of garden plants and becomes a tree, so that the birds come and perch in its branches.",
      reference: "Matthew 13:31-32"
    },
    {
      text: "Do not be deceived: God cannot be mocked. A man reaps what he sows.",
      reference: "Galatians 6:7"
    },
    {
      text: "The seed falling on good soil refers to someone who hears the word and understands it. This is the one who produces a crop, yielding a hundred, sixty or thirty times what was sown.",
      reference: "Matthew 13:23"
    },
    {
      text: "And the Lord will guide you continually, and satisfy your soul in drought, and strengthen your bones; you shall be like a watered garden, and like a spring of water, whose waters do not fail.",
      reference: "Isaiah 58:11"
    },
    {
      text: "He who sows sparingly will also reap sparingly, and he who sows generously will also reap generously.",
      reference: "2 Corinthians 9:6"
    },
    {
      text: "The earth is the Lord’s, and everything in it, the world, and all who live in it.",
      reference: "Psalm 24:1"
    },
    {
      text: "But the seed on good soil stands for those with a noble and good heart, who hear the word, retain it, and by persevering produce a crop.",
      reference: "– Luke 8:15"
    },
    {
      text: "I planted the seed, Apollos watered it, but God has been making it grow.",
      reference: "1 Corinthians 3:6"
    },
    {
      text: "And the seed whose fruit is righteousness is sown in peace by those who make peace.",
      reference: "James 3:18"
    }
  ];

  // Define the main verse (it will appear more frequently)
  const mainVerse = verses[0]; // This will be the "main" verse picked more often
  
  // Function to get a random verse, with weighted selection for the main verse
  const getRandomVerse = () => {
    // Weighted selection: 4 chances for the main verse, 1 chance for each other verse
    const random = Math.random();
    if (random < 0.75) {
      return mainVerse; // 40% chance for the main verse
    } else {
      const randomIndex = Math.floor(Math.random() * (verses.length - 1)) + 1; // Exclude the main verse
      return verses[randomIndex];
    }
  };

  // State to store the selected verse
  const [verse, setVerse] = useState(null);

  // Set the random verse when the component mounts
  useEffect(() => {
    const selectedVerse = getRandomVerse();
    setVerse(selectedVerse);
  }, []);


  return (
    <div className="verse-container text-center p-4 mx-auto">
      {verse && (
        <blockquote className="text-xs text-cyan-100/60">
          <p>「 {verse.text} 」</p>
          <footer className="text-xs text-cyan-100/60 italic">{verse.reference}</footer>
        </blockquote>
      )}
    </div>
  );
};

export default SeedVerse;
